import { ContextMenu, Input, LeftSideList, SideHeader, TnModal } from "bimui";
import { ReactComponent as AddSvg } from 'bimui/dist/c1/icons/new-default.svg';
import { ReactComponent as BlackAddSvg } from "./icons/add.svg"
import "./index.less"
import TreeComponent, { TreeNode } from "./tree";
import { useEffect, useState } from "react";
import { ParamGroupType, ParamGroupTypeOption, ParamTypeOption } from "@/declare/enums/param-type";
import { BaseUtils } from "tnbase";
import { addParam, addParamFormula, addParamGroup, deleteParam, deleteParamFormula, deleteParamGroup, findGroupMapListByType, updateParam, updateParamFormula, updateParamGroup } from "@/declare/api/system-lib/param";
import { ParamGroup } from "@/declare/interface/system-lib/param-group";
import { message } from "antd";
import { Param } from "@/declare/interface/system-lib/param";
import { ParamFormula } from "@/declare/interface/system-lib/param-formula";
import { emitter } from '@/utils/mitt';
import { Emit_Event_Common_Tool } from "@/declare/enums/emit-event";
import { useLocation, useNavigate, useParams } from "react-router-dom";

/**
 * 树状结构类型
 */
const TreeParamType = {
    GROUP: 1,
    PARAM: 2,
    FORMULA: 3
}

export default function ParamPanel() {
    const navigate = useNavigate();
    /**
     * 从 URL 中提取项目 UUID 参数
     */
    const { projectUuid } = useParams();
    /**
     * 控制右键菜单的显示状态
     */
    const [contextMenuVisible, setContextMenuVisible] = useState<boolean>(false)
    /**
     * 右键菜单的左侧位置
     */
    const [contextMenuLeft, setContextMenuLeft] = useState<number>(0)
    /**
     * 右键菜单的顶部位置
     */
    const [contextMenuTop, setContextMenuTop] = useState<number>(0)
    /**
     * 激活的节点
     */
    const [activeLeftType, setActiveLeftType] = useState<number>(ParamGroupType.ENVIRONMENT)
    /**
     * 树源数据
     */
    const [treeData, setTreeData] = useState<TreeNode[]>([])
    /**
     * 激活的节点
     */
    const [activeNode, setActiveNode] = useState<TreeNode>(null)
    /**
     * 删除事件的uuid
     */
    const [eventDelUuid, setEventDelUuid] = useState(null);
    /**
     * 页面loading
     */
    const [loading, setLoading] = useState<boolean>(false);
    /**
     * 添加后需要展开的父项
     */
    const [showItemKey, setShowItemKey] = useState<string>()
    /**
     * 搜索字符串
     */
    const [searchValue, setSearchValue] = useState<string>()

    const location = useLocation(); // 获取当前路由的路径

    useEffect(() => {
        if (!location?.pathname) return
        let url = location.pathname
        const regex = /formulas\/([^/]+)/;
        const match = url.match(regex);

        if (match) {
            let node: TreeNode = {
                key: match[1],
                valueCount: 1,
                type: TreeParamType.FORMULA
            }
            setActiveNode(node)
        }
    }, [location.pathname])

    useEffect(() => {
        if (!activeLeftType) return
        generateData();
    }, [activeLeftType])


    /**
     * 删除操作的回调，每次修改了eventDelUuid后触发删除逻辑
     */
    useEffect(() => {
        if (eventDelUuid != null) {
            handleDelete();
        }
    }, [eventDelUuid])


    /**
     * 单击激活节点
     * @param node 
     */
    const onClickActiveNode = (node: TreeNode) => {
        if (node && node.type === TreeParamType.FORMULA) {
            let url = location.pathname
            if (url.includes("projects")) {
                navigate(`/projects/${projectUuid}/formulas/${node.key}`);
            } else {
                navigate(`/system-lib/formulas/${node.key}`);
            }
        }
        setActiveNode(node);
    }


    // 顶部菜单栏的删除事件
    const onClickMenuDelete = () => {
        setEventDelUuid(BaseUtils.genUUID());
    }

    // 删除操作
    const handleDelete = () => {
        if (activeNode == null || loading) return;
        setLoading(true);
        TnModal().deleteModal({
            onOk() {
                switch (activeNode.type) {
                    case TreeParamType.GROUP:
                        deleteParamGroup(activeNode.key).then(res => {
                            generateData();
                        }).catch(err => {
                            message.error("删除失败");
                        }).finally(() => {
                            setLoading(false);
                            TnModal().destoryAll();
                        })
                        break;
                    case TreeParamType.PARAM:
                        deleteParam(activeNode.key).then(res => {
                            generateData();
                        }).catch(err => {
                            message.error("删除失败");
                        }).finally(() => {
                            setLoading(false);
                            TnModal().destoryAll();
                        })
                        break;
                    case TreeParamType.FORMULA:
                        deleteParamFormula(activeNode.key).then(res => {
                            generateData();
                        }).catch(err => {
                            message.error("删除失败");
                        }).finally(() => {
                            setLoading(false);
                            TnModal().destoryAll();
                        })
                        break;
                }
            },
        })
    }


    /**
     * 监听顶部工具栏的删除按钮
     */
    useEffect(() => {
        emitter.on(Emit_Event_Common_Tool.DELETE, onClickMenuDelete);
        return () => {
            emitter.off(Emit_Event_Common_Tool.DELETE, onClickMenuDelete);
        }
    }, [])

    const generateData = () => {
        findGroupMapListByType(activeLeftType).then(res => {
            let groupList: ParamGroup[] = res.data || []
            let tData = generateTreeData(groupList)
            setTreeData([...tData])
        })
    }

    const generateTreeData = (groupList: ParamGroup[]) => {
        let treeData: TreeNode[] = groupList.map(group => transformGroupToNode(group))
        return treeData
    }

    const transformGroupToNode = (group: ParamGroup): TreeNode => {
        let node: TreeNode = {
            key: group.uuid,
            valueCount: 1,
            value1: group.name,
            type: TreeParamType.GROUP,
            children: []
        }
        if (group?.groupList?.length > 0) {
            group.groupList.forEach(childGroup => {
                node.children.push(transformGroupToNode(childGroup))
            })
        }
        if (group?.paramList?.length > 0) {
            group.paramList.forEach(childParam => {
                let formulas = childParam.formulaList || [];
                let children = [];
                formulas.forEach(formula => {
                    let childrenNode: TreeNode = {
                        key: formula.uuid,
                        valueCount: 1,
                        value1: formula.name,
                        type: TreeParamType.FORMULA,
                    };
                    children.push(childrenNode);
                })
                node.children.push({
                    key: childParam.uuid,
                    valueCount: 2,
                    value1: childParam.name,
                    value2: childParam.keyCode,
                    type: TreeParamType.PARAM,
                    emptySvgShow: true,
                    children: children
                })
            })
        }
        return node
    }

    /**
     * 点击参数添加，显示添加选项弹窗
     * @returns 
     */
    const onAddClick = () => {
        if (activeNode && activeNode.type === TreeParamType.PARAM) {
            onClickAddFormula();
            return;
        }
        let dom = document.getElementById("param-add-svg")
        if (!dom) return
        const rect = dom.getBoundingClientRect();
        setContextMenuLeft(rect.left);
        setContextMenuTop(rect.bottom + 4);
        setContextMenuVisible(true)
    }

    /**
     * 添加组
     */
    const onClickAddGroup = () => {
        setShowItemKey(activeNode?.key)
        let newGroup: ParamGroup = {
            uuid: BaseUtils.genUUID(),
            parentUuid: activeNode?.key,
            type: activeLeftType,
            name: "新建组"
        }
        addParamGroup(newGroup).then(res => {
            generateData()
        }).catch(e => {
            message.error("添加失败！")
        })
    }

    const onClickAddParam = () => {
        if (!activeNode) return
        setShowItemKey(activeNode.key)
        if (activeNode.type != TreeParamType.GROUP) return;
        let uuid = BaseUtils.genUUID();
        let newParam: Param = {
            uuid: BaseUtils.genUUID(),
            groupUuid: activeNode.key,
            name: "新参数",
            keyCode: "TODO" + uuid.substring(0, 8)
        }
        addParam(activeNode.key, newParam).then(res => {
            generateData()
        }).catch(e => {
            message.error("添加失败！")
        })
    }

    const onClickAddFormula = () => {
        if (!activeNode) return;
        if (activeNode.type != TreeParamType.PARAM) return;
        let newFormula: ParamFormula = {
            uuid: BaseUtils.genUUID(),
            paramUuid: activeNode.key,
            formula: '',
            formulaCode: '',
            name: '新公式'
        }
        addParamFormula(activeNode.key, newFormula).then(res => {
            generateData()
        }).catch(e => {
            message.error("添加失败！")
        })

    }

    /**
     * 更新节点数据
     * @param treeNode 
     * @param value 
     * @param count 
     */
    const updateNode = (treeNode: TreeNode, value: string, count?: number) => {
        if (treeNode.type == TreeParamType.GROUP) {
            updateParamGroup(treeNode.key, { name: value }).catch(e => {
                message.error("修改失败！")
            })
        } else if (treeNode.type == TreeParamType.PARAM) {
            let updateData: Param = {}
            if (count == 1) {
                updateData.name = value
            } else {
                updateData.keyCode = value
            }
            updateParam(treeNode.key, updateData).catch(e => {
                message.error("修改失败！")
            })
        } else if (treeNode.type === TreeParamType.FORMULA) {
            updateParamFormula(treeNode.key, { name: value }).catch(e => {
                message.error("修改失败！")
            })
        }
    }

    return (
        <div className="param-panel-main">
            <SideHeader>
                <div className='header'>
                    <span>参数</span>
                    <AddSvg id="param-add-svg" className='add-icon' onClick={() => { onAddClick() }} />
                </div>
            </SideHeader>
            <div className="param-panel-body">
                <div className="body-head">
                    <Input value={searchValue} onChange={(e) => { setSearchValue(e.target.value) }} />
                </div>
                <div className="body-main">
                    <div className="left-body">
                        <LeftSideList
                            leftItems={ParamGroupTypeOption}
                            uniqueKey="type"
                            activeLeftItemKey={activeLeftType}
                            leftItemUpdateUuid={BaseUtils.genUUID()}
                            onClickLeftItem={(e, item) => {
                                setActiveLeftType(item.type)
                            }}
                            leftItemContainer={({ leftItem }) => {
                                return (
                                    <div>{leftItem.label}</div>
                                );
                            }}
                            noNeedAddIcon
                        />
                    </div>
                    <div className="right-body">
                        <TreeComponent
                            searchValue={searchValue}
                            showItemKey={showItemKey}
                            clickEmptyToCleanActive={true}
                            activeNode={activeNode}
                            treeList={treeData}
                            onActiveNode={onClickActiveNode}
                            onEditNodeConfirm={(node: TreeNode, value, count) => {
                                updateNode(node, value, count)
                            }} />
                    </div>
                </div>
            </div>

            <ContextMenu
                wrapperClassname="add-param-menu"
                visible={contextMenuVisible}
                left={contextMenuLeft}
                top={contextMenuTop}
                onCancel={() => { setContextMenuVisible(false) }}
            >
                {(!activeNode || activeNode.type == TreeParamType.GROUP) && (
                    <>
                        <div className="param-menu-item" onClick={() => {
                            onClickAddGroup()
                            setContextMenuVisible(false)
                        }}>
                            <BlackAddSvg style={{ marginLeft: 4 }} />
                            新建组
                        </div>
                        <div className="param-menu-item" onClick={() => {
                            onClickAddParam()
                            setContextMenuVisible(false)
                        }}>
                            <BlackAddSvg style={{ marginLeft: 4 }} />
                            新建参数
                        </div>
                    </>
                )}
            </ContextMenu>
        </div>
    )
}